import { getTenantFromHostname } from "@/utils/get-tenant-from-hostname";
import { Box, Button } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TicketCreateRequest } from "../..";
import CustomTextArea from "../../../components/CustomTextArea";
import Flex from "../../../components/Flex";
import Input from "../../../components/Input";
import DropZone from "../../../components/app/DropZone";
import { useSnackbar } from "../../../hooks/useSnackbar";
import { getPublicRealm } from "../../../layout/app/patient-portal/public-view/dob-validation/useValidateDob";
import { useRaiseTicket } from "../../../queries/help-support/use-raise-ticket";
import { convertToBase64, showToastOnApiCall } from "../../../utils/utils";

const RaiseTicket = ({ onSuccess }: { onSuccess: () => void }) => {
  const { mutateAsync: raiseTicket } = useRaiseTicket();
  const showSnackbar = useSnackbar();
  const xTENANTID = getPublicRealm() || getTenantFromHostname();

  const handleRaiseTicket = (
    values: TicketCreateRequest & { attachments?: string }
  ) => {
    const payload: TicketCreateRequest = {
      // todo: by default set to ticket as per B.E
      ticketType: "TICKET",
      ...values,
      attachments: values?.attachments
        ? [{ attachment: values?.attachments }]
        : undefined,
    };

    showToastOnApiCall({
      apiCall: raiseTicket({
        ticketCreateRequest: payload,
        xTENANTID: xTENANTID,
      }),
      showSnackbar,
      onSave: () => {
        onSuccess();
      },
    });
  };

  const formik = useFormik<TicketCreateRequest & { attachments?: string }>({
    initialValues,
    validationSchema,
    onSubmit: handleRaiseTicket,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Flex flexDirection="column" gap={3}>
        <Input
          label="What is your question"
          required
          textFieldProps={{
            name: "question",
            value: formik.values.question,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "Enter your question",
          }}
          error={(formik.touched.question && formik.errors.question) as any}
        />

        <CustomTextArea
          label="Provide as much detail as possible about your question"
          required
          minRows={4}
          name="questionDetails"
          value={formik.values.questionDetails}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Enter details"
          error={
            (formik.touched.questionDetails &&
              formik.errors.questionDetails) as any
          }
        />

        <Box>
          <DropZone
            height="120px"
            accept="all"
            content="Choose File"
            label="Attach any relevant files (file should not exceed 5 MB)"
            onClick={async (files) => {
              const file = files?.item(0) || null;
              const base64File = await convertToBase64(file as File);
              formik.setFieldValue("attachments", base64File);
            }}
            error={
              (formik.touched.attachments && formik.errors.attachments) as any
            }
          />
        </Box>

        <Input
          label="Your Email"
          required
          textFieldProps={{
            name: "email",
            type: "email",
            value: formik.values.email,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "Email",
          }}
          error={(formik.touched.email && formik.errors.email) as any}
        />

        <Flex justifyContent="flex-end">
          <Button variant="contained" type="submit">
            Send
          </Button>
        </Flex>
      </Flex>
    </form>
  );
};

export default RaiseTicket;

const initialValues = {
  question: "",
  questionDetails: "",
  email: "",
  attachments: undefined,
};

const validationSchema = Yup.object({
  question: Yup.string().required("Question is required"),
  questionDetails: Yup.string().required("Details are required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  //   attachments: Yup.mixed().test(
  //     "fileSize",
  //     "File size must be less than 5MB",
  //     (value) => {
  //       if (!value) return true;
  //       return (value as File).size <= 5 * 1024 * 1024;
  //     }
  //   ),
});
